import React from 'react';

const TermsOfServicePage: React.FC = () => {
  return (
    <div className="w-full max-w-4xl bg-white p-8 rounded-lg shadow-lg">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Terms of Service</h1>
      <p className="text-sm text-gray-500 mb-8">Last Updated: September 27, 2026</p>

      <div className="space-y-6 text-gray-700">
        <p>
          Typing Masters is a product offered by Cesdiacomm, LLC ("Typing Masters", "we", or "us"). Typing Masters provides a web-based typing instruction and practice service ("Service" or "Services") designed for educational institutions. At this time, full Services are available only to registered schools and their students, while a Demo section of the website is open to the public for preview purposes.
        </p>
        <p>
          By using our website and Services, you agree to these Terms of Service (“Terms”) and our Privacy Policy. If you do not agree, please discontinue use of the Service. We may update these Terms at our discretion. If material changes are made, we will notify schools and users accordingly.
        </p>

        <div>
          <h2 className="text-xl font-semibold mb-2">1. School Registration and Student Accounts</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Only authorized teachers and school officials may register for full access and may create or manage student/child accounts.</li>
            <li>Self-registration by students or children is not permitted.</li>
            <li>Student accounts do not use or require a student's real name: each student is identified only by a short, anonymous username assigned by their teacher (a class prefix plus a sequential number, e.g. "cls51"), paired with a password. Teachers are responsible for keeping the class roster (which student holds which username) accurate on their own records.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">2. Account Recovery</h2>
          <p>There is no automated, self-service "forgot password" email for any account type. Passwords are reset by the next role up in the school hierarchy: a teacher resets a student's password, a school administrator resets a teacher's or parent's password, and a platform administrator resets a school administrator's password.</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">3. Demo Section</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>The Demo section of Typing Masters is accessible to the public for non-commercial, evaluative use.</li>
            <li>No personal account is necessary to access the Demo section.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">4. Privacy</h2>
          <p>Personal information provided to Typing Masters is handled according to our Privacy Policy.</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">5. Use of the Services by Children</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Children under 13 may use Typing Masters only under a registered school account and with a teacher’s consent as required by law (such as COPPA).</li>
            <li>Parents and legal guardians may contact support@TypeoGO.com to inquire about, review, or request deletion of their child’s information or to revoke consent.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">6. Special Terms for School Officials</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>School officials may access student progress and information strictly for educational purposes, consistent with all applicable laws.</li>
            <li>Disclosure of student data is only allowed as legally permitted or as described in these Terms.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">7. Restrictions on Use or Access</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Services and content are proprietary to Cesdiacomm, LLC and may not be copied, distributed, or reverse engineered, except as expressly allowed.</li>
            <li>You may not use the Service for unlawful purposes or interfere with others’ use or access.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">8. Cancelling Service</h2>
          <p>Teachers and school officials may request account deletion by contacting support@TypeoGO.com. Student accounts can also be deleted by the managing teacher or school.</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">9. Termination</h2>
          <p>Cesdiacomm, LLC may suspend or terminate accounts at its discretion and for any reason. After termination, access to the Services must cease.</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">10. Warranty Disclaimer</h2>
          <p>The Service is provided “AS IS”. We disclaim all warranties, express or implied, including merchantability, fitness for purpose, and non-infringement.</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">11. Limitation of Liability and Indemnification</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Cesdiacomm, LLC shall not be liable for indirect, incidental, or consequential damages. Liability is limited as described in this section.</li>
            <li>You agree to indemnify Cesdiacomm, LLC for any misuse of the Services or breach of these Terms.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">12. Governing Law</h2>
          <p>These Terms shall be governed solely by and construed in accordance with the laws of the Commonwealth of Massachusetts, U.S.A., without regard to its conflict of law provisions. All disputes must be resolved in the courts of the Commonwealth of Massachusetts.</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">13. Notices</h2>
          <p>All notices, inquiries, or legal requests must be sent to support@TypeoGO.com.</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">14. Miscellaneous</h2>
          <p>These Terms and the Privacy Policy constitute the complete agreement regarding your use of the Service.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;